import React, { useContext as useContextCore } from 'react'
import type { CarrierRate, GroupedCarrierRate } from '../../../index'
import { useGroupedCarrierRate } from '../../../index'
import type { UseListResult } from '@ztechapps/common.hook'

export type ContextProps = {
  children?: React.ReactNode
}

export type ContextType = {
  groupedByCarrierRate?: [GroupedCarrierRate, UseListResult<CarrierRate>]
} & Omit<ContextProps, 'children'>

const context = React.createContext<ContextType>(null)
const CoreProvider = context.Provider

export const ShippingRatePanelProvider = ({ children }: ContextProps) => {
  const groupedByCarrierRate = useGroupedCarrierRate()

  return <CoreProvider value={{ groupedByCarrierRate }}>{children}</CoreProvider>
}

export const useShippingRatePanelContext = () => useContextCore(context)
